import React, { useState } from 'react';
import { motion } from 'framer-motion';
interface BeforeAfterSliderProps {
  beforeImage: string;
  afterImage: string;
  caption: string;
}
export function BeforeAfterSlider({
  beforeImage,
  afterImage,
  caption
}: BeforeAfterSliderProps) {
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);
  const handleMove = (clientX: number, rect: DOMRect) => {
    const x = Math.max(0, Math.min(clientX - rect.left, rect.width));
    const percent = Math.max(0, Math.min(x / rect.width * 100, 100));
    setSliderPosition(percent);
  };
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!isDragging) return;
    const rect = e.currentTarget.getBoundingClientRect();
    handleMove(e.clientX, rect);
  };
  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    handleMove(e.touches[0].clientX, rect);
  };
  return <div className="w-full" data-id="element-16">
      <div className="relative w-full h-[300px] md:h-[400px] rounded-lg overflow-hidden cursor-ew-resize select-none" onMouseMove={handleMouseMove} onMouseDown={() => setIsDragging(true)} onMouseUp={() => setIsDragging(false)} onMouseLeave={() => setIsDragging(false)} onTouchMove={handleTouchMove} data-id="element-17">
        <img src={afterImage} alt="After" className="absolute inset-0 w-full h-full object-cover" data-id="element-18" />
        <div className="absolute inset-0 w-full h-full overflow-hidden" style={{
        clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`
      }} data-id="element-19">
          <img src={beforeImage} alt="Before" className="absolute inset-0 w-full h-full object-cover" data-id="element-20" />
        </div>

        <div className="absolute top-0 bottom-0 w-1 bg-white cursor-ew-resize" style={{
        left: `${sliderPosition}%`
      }} data-id="element-21">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-white rounded-full shadow-lg flex items-center justify-center" data-id="element-22">
            <div className="flex gap-1" data-id="element-23">
              <div className="w-0.5 h-4 bg-brand-bg" data-id="element-24" />
              <div className="w-0.5 h-4 bg-brand-bg" data-id="element-25" />
            </div>
          </div>
        </div>

        <div className="absolute top-4 left-4 bg-black/70 text-white px-3 py-1 rounded font-body text-sm" data-id="element-26">
          Before
        </div>
        <div className="absolute top-4 right-4 bg-black/70 text-white px-3 py-1 rounded font-body text-sm" data-id="element-27">
          After
        </div>
      </div>
      <p className="font-body text-white/80 text-center mt-4" data-id="element-28">{caption}</p>
    </div>;
}